import { AxiosResponse } from "axios";
import { axiosCoreInstance } from "../../../AxiosCoreInterceptor";
import * as ApiUrls from './ApiUrl.PrescribedMatters';
import { EEPrescribedMattersDto } from "../../../../Model/Dto/EmploymentEquity/Plan/EEPrescribedMatters";

export const PrescribedMattersService = {
    GetPrescribedMatters: (id: string): Promise<AxiosResponse<EEPrescribedMattersDto.Dto>> => axiosCoreInstance.get(`${ApiUrls.PrescribedMatters}/${id}`),
    SavePrescribedMatters: (prescribedMatters: EEPrescribedMattersDto.Dto): Promise<AxiosResponse<EEPrescribedMattersDto.Dto>> => axiosCoreInstance.post(ApiUrls.PrescribedMatters, prescribedMatters),
}